"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSourceTypes = void 0;
var url_1 = __importDefault(require("url"));
var lodash_1 = __importDefault(require("lodash"));
var createSourceTypes = function () {
    var isIframe = function (input) {
        return lodash_1.default.includes(input, "<iframe");
    };
    var getIframeSrc = function (input, targets) {
        var url = input;
        if (isIframe(input)) {
            url = $(input).attr("src");
        }
        var includesTarget = targets.find(function (target) { return lodash_1.default.includes(url, target); }) !== undefined;
        if (includesTarget) {
            return url;
        }
        else {
            return null;
        }
    };
    return [
        {
            name: "Google Maps",
            internal: "googleMaps",
            website: "https://maps.google.com",
            icon: "GoogleMapsLogo.png",
            description: "Google's free mapping service, provide beautiful, interactive, full-color maps.",
            explainer: 'To find the embed code for a Google Map follow <a href="https://support.google.com/maps/answer/3544418?hl=en&rd=1" target="_blank">these instructions</a>',
            getUrl: function (input) {
                var url = input;
                if (isIframe(input)) {
                    url = $(input).attr("src");
                }
                var urlObj = url_1.default.parse(url);
                if (lodash_1.default.includes(urlObj.hostname, "google.") &&
                    lodash_1.default.includes(urlObj.path, "maps") &&
                    lodash_1.default.includes(urlObj.path, "embed")) {
                    return url;
                }
                else {
                    return null;
                }
            },
        },
        {
            name: "Google Forms",
            internal: "googleForms",
            website: "https://www.google.com/forms/about/",
            icon: "GoogleFormsLogo.png",
            description: "Google's forms service. Allows for text questions, multiple choice and more. Part of the free Google Docs platform.",
            explainer: 'To find the embed code for a Google Form follow <a href="https://support.google.com/drive/answer/2494822?hl=en" target="_blank">these instructions</a>',
            getUrl: function (input) {
                var url = input;
                if (isIframe(input)) {
                    url = $(input).attr("src");
                }
                var urlObj = url_1.default.parse(url);
                if (lodash_1.default.includes(urlObj.hostname, "docs.google") && lodash_1.default.includes(urlObj.path, "forms")) {
                    return url;
                }
                else {
                    return null;
                }
            },
        },
        {
            name: "Google Sheets",
            internal: "googleSheets",
            website: "https://www.google.com/sheets/about/",
            icon: "GoogleSheetsLogo.png",
            description: "Google's free spreadsheet tool. A cloud-based editor. Part of the free Google Docs platform.",
            explainer: 'To get a shareable link for a Google Sheet follow <a href="https://support.google.com/drive/answer/2494822?hl=en" target="_blank">these instructions</a>',
            getUrl: function (input) {
                var url = input;
                if (isIframe(input)) {
                    url = $(input).attr("src");
                }
                var urlObj = url_1.default.parse(url);
                if (lodash_1.default.includes(url, "docs.google") && lodash_1.default.includes(urlObj.path, "spreadsheets")) {
                    return url;
                }
                else {
                    return null;
                }
            },
        },
        {
            name: "Microsoft Powerpoint",
            internal: "microsoftPowerpoint",
            website: "https://www.microsoft.com/en-ww/microsoft-365/powerpoint",
            icon: "MicrosoftPowerpointLogo.png",
            description: "Create well-designed, impactful slides with the help of Designer and Ideas in PowerPoint.",
            explainer: 'To get a shareable link for a Microsoft Powerpoint follow <a href="https://support.microsoft.com/en-au/office/embed-a-presentation-in-a-web-page-or-blog-19668a1d-2299-4af3-91e1-ae57af723a60#:~:text=Open%20your%20presentation%20in%20PowerPoint,Share%2C%20and%20then%20click%20Embed.&text=In%20the%20Embed%20box%2C%20under,Copy%2C%20and%20then%20click%20Close." target="_blank">these instructions</a>',
            getUrl: function (input) {
                return getIframeSrc(input, ["onedrive.live", "sharepoint", "microsoft"]);
            },
        },
        {
            name: "Microsoft Excel",
            internal: "microsoftExcel",
            website: "https://www.microsoft.com/en-us/microsoft-365/excel",
            icon: "MicrosoftExcelLogo.png",
            description: "Turn data into insights with free and premium spreadsheets.",
            explainer: 'To get a shareable link for a Microsoft Excel follow <a href="https://support.microsoft.com/en-us/office/share-it-embed-an-excel-workbook-on-your-web-page-or-blog-from-onedrive-804e1845-5662-487e-9b38-f96307144081" target="_blank">these instructions</a>',
            getUrl: function (input) {
                return getIframeSrc(input, ["onedrive.live", "sharepoint", "microsoft"]);
            },
        },
        {
            name: "Microsoft Word",
            internal: "microsoftWord",
            website: "https://www.microsoft.com/en-ww/microsoft-365/word",
            icon: "MicrosoftWordLogo.png",
            description: "Elevate your writing, create beautiful documents, and collaborate with others—anywhere, anytime.",
            explainer: 'To get a shareable link for a Microsoft Word follow <a href="https://support.microsoft.com/en-us/office/embed-a-word-document-in-your-blog-0faa0253-2751-44bf-8486-ea7837fe7db1" target="_blank">these instructions</a>',
            getUrl: function (input) {
                return getIframeSrc(input, ["onedrive.live", "sharepoint", "microsoft"]);
            },
        },
        {
            name: "Typeform",
            internal: "typeform",
            website: "https://typeform.com",
            icon: "TypeformLogo.png",
            description: "Build beautiful and engaging online forms, surveys, quizzes, landing pages and much more.",
            explainer: 'Copy the URL for your Typeform from the "Share your typeform" tab and paste it below. <a href="https://help.qwilr.com/integrations/embed-block/typeforms" target="_blank">Check out the Typeform support docs</a> for help.',
            placeholderText: "Typeform survey link...",
            getUrl: function (input) {
                var url = url_1.default.parse(input);
                if (lodash_1.default.includes(url.hostname, "typeform.com")) {
                    return input;
                }
                else {
                    return null;
                }
            },
        },
        {
            name: "Slideshare",
            internal: "slideshare",
            website: "https://slideshare.net",
            icon: "SlideshareLogo.png",
            description: "Share PowerPoint presentations, Word documents and Adobe PDF Portfolios.",
            explainer: "Visit the Slideshare that you wish to embed. Click the Embed button at the top right of the player. Copy the Embed code.",
            getUrl: function (input) {
                var url = input;
                if (isIframe(input)) {
                    url = $(input).attr("src");
                }
                if (url && url.startsWith("//")) {
                    url = url.replace("//", "https://");
                }
                var urlObj = url_1.default.parse(url);
                if (lodash_1.default.includes(urlObj.hostname, "slideshare.net")) {
                    return url;
                }
                else {
                    return null;
                }
            },
        },
        {
            name: "Calendly",
            internal: "calendly",
            website: "https://calendly.com",
            icon: "CalendlyLogo.png",
            description: "Schedule appointments and meetings with Calendly.",
            explainer: "Simply copy the URL for your Calendly and paste it below.",
            placeholderText: "https://calendly.com/your-profile",
            getUrl: function (url) {
                if (/^calendly.com/.test(url)) {
                    url = "https://".concat(url);
                }
                var urlObj = url_1.default.parse(url);
                if (urlObj.hostname === "calendly.com") {
                    return url;
                }
                else {
                    return null;
                }
            },
        },
        {
            name: "Invision",
            internal: "invision",
            website: "https://www.invisionapp.com/",
            icon: "InvisionLogo.png",
            description: "Invision is a prototyping, collaboration & workflow platform.",
            explainer: "<p>Visit the Invision screen you wish to embed. Click the top-right button and the first button (Live Embed). Go to Custom Embed and copy the Live Embed Code.</p><p>Invision will only let you embed Desktop-size prototypes; if the image is larger than this, it will download the image instead.</p>",
            getUrl: function (url) {
                var urlObj = url_1.default.parse(url);
                if (urlObj.hostname === "projects.invisionapp.com") {
                    return url;
                }
                else {
                    return null;
                }
            },
        },
        {
            name: "Prezi",
            internal: "prezi",
            website: "https://prezi.com/",
            icon: "PreziLogo.svg",
            description: "Create more engaging, persuasive, and memorable presentations with Prezi.",
            explainer: "Visit the Prezi that you wish to embed. Click the Embed button below the player. Copy the Embed code.",
            getUrl: function (input) {
                return getIframeSrc(input, ["prezi.com"]);
            },
        },
        {
            name: "Paperform",
            internal: "paperform",
            icon: "paperform.png",
            description: "Create beautiful forms with Paperform",
            explainer: "Enter the URL of your paper form",
            placeholderText: "https://your-form.paperform.co",
            getUrl: function (url) {
                if (/[a-zA-Z]+?\.paperform.co$/.test(url)) {
                    return url;
                }
                else {
                    return null;
                }
            },
        },
        {
            name: "Infogram",
            internal: "infogram",
            website: "https://infogr.am",
            icon: "InfogramLogo.png",
            description: "Infogram creates beautiful data visualisations. Interactive, responsive and engaging.",
            explainer: "Simply copy the URL for your Infogram and paste it below. You can find it by clicking 'Share' and copying the url under 'Social Media'.",
            placeholderText: "https://infogram.com/your-project",
            getUrl: function (url) {
                var urlObj = url_1.default.parse(url);
                if (urlObj.hostname === "e.infogram.com") {
                    return url;
                }
                else if (urlObj.hostname === "infogram.com" || urlObj.hostname === "infogr.am") {
                    urlObj.host = "e.infogram.com";
                    return "".concat(url_1.default.format(urlObj), "?src=embed");
                }
                else {
                    return null;
                }
            },
        },
        {
            name: "TwentyThree",
            internal: "twentyThree",
            website: "https://www.twentythree.net/",
            icon: "TwentyThreeLogo.png",
            description: "TwentyThree coordinates, manages, and tracks videos.",
            explainer: 'To find the embed code for a TwentyThree video follow <a href="https://help.qwilr.com/article/694-embedding-videos-from-twenty-three" target="_blank">these instructions</a>.',
            getUrl: function (input) {
                var url = input;
                var iframe = $(input).find("iframe");
                if (iframe.length > 0) {
                    url = iframe.attr("src");
                }
                var urlObj = url_1.default.parse(url);
                if (lodash_1.default.includes(urlObj.hostname, "video.twentythree.net")) {
                    return url;
                }
                else {
                    return null;
                }
            },
        },
        {
            name: "Iframe Embed",
            internal: "iframeEmbed",
            icon: "IframeEmbed.png",
            description: "For services which have embeddable widgets available through an Iframe.",
            explainer: "Paste in the Iframe embed code below.",
            getUrl: function (url) {
                if (url === "") {
                    return null;
                }
                var confirmedUrl = isIframe(url) ? $(url).attr("src") : url;
                var urlObj = url_1.default.parse(confirmedUrl);
                if (urlObj.hostname.includes("dropbox")) {
                    if (urlObj.query && urlObj.query.length > 0) {
                        urlObj.query += "&raw=1";
                    }
                    else {
                        urlObj.query = "raw=1";
                    }
                    urlObj.search = "?".concat(urlObj.query);
                    return url_1.default.format(urlObj);
                }
                else {
                    return confirmedUrl;
                }
            },
        },
    ];
};
exports.createSourceTypes = createSourceTypes;
